module.exports = __webpack_public_path__ + "static/media/sodexo.edad9a25.png";